import { ESharedFunction } from "motw_core/Enums/ESharedFunction";
import * as React from "react";
import { FormInput } from "source/app/presentation/Shared/Form/Input/FormInput";
import { EGlyphicon } from "source/app/presentation/Shared/Glyphicon/EGlyphicon";
import Render from "source/app/presentation/Shared/Render";
import { StyleClass } from "source/app/presentation/Shared/Styles/CSS";
import IconWithText from "source/app/services/Shared/IconWithText/IconWithText";
import { IncreaseValueAsync } from "source/app/presentation/MainPanel/LifeChangingEvents/UnderDevelopment/CICO/Helpers/IncreaseCICOValueAsync";
import UI from "source/app/services/UI/UI";
import { IKeyValue } from "motw_core/Entity/IKeyValue";
import { IsToday } from "source/app/services/Time/Time";

export function ChangeCICOValue({
    increaseBy,
    setIncreaseBy,
    sharedFunction,
    keyValue,
}: {
    setIncreaseBy: React.Dispatch<React.SetStateAction<number>>;
    increaseBy: number;
    sharedFunction: ESharedFunction;
    keyValue: IKeyValue;
}) {
    const isResetRequired = !IsToday(keyValue.lastmodifiedtime);

    if (isResetRequired) {
        return <div>please reset counter</div>;
    }

    return (
        <div>
            <FormInput
                id={`clickTarget_input_${ESharedFunction[sharedFunction]}`}
                classes={StyleClass(`ChangeCalories_Input`, {
                    fontSize: `30px`,
                })}
                label="increase by"
                type="number"
                onFocus={() => setIncreaseBy(0)}
                onChange={async (event) => {
                    const newValue = Number.parseInt(event.target.value);
                    setIncreaseBy(newValue);
                }}
                onEnter={async () => {
                    setIncreaseBy(0);
                    MoveFocusToNextInputBox(sharedFunction);
                    await IncreaseValueAsync(increaseBy, sharedFunction);
                }}
                value={increaseBy}
                width="80px"
            />
            <Render id="IncreaseCICOValueLink" when={increaseBy > 0}>
                <span style={{ margin: `5px` }}>
                    <IconWithText
                        iconSuffix={EGlyphicon.plus}
                        whenClicked={async () => {
                            setIncreaseBy(0);
                            await IncreaseValueAsync(
                                increaseBy,
                                sharedFunction
                            );
                        }}
                        displayAsBlock={false}
                    />
                </span>
            </Render>
        </div>
    );
}

function MoveFocusToNextInputBox(sharedFunction: ESharedFunction) {
    const nextFocusTarget =
        sharedFunction === ESharedFunction.CICO_calories
            ? ESharedFunction.CICO_protein
            : ESharedFunction.CICO_calories;

    UI.FocusOnElement(`clickTarget_input_${ESharedFunction[nextFocusTarget]}`);
}
